import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useTranslation } from './I18nContext';
import { useLoading } from './Loading';
import { mockBatches, mockStudents, mockBatchEnrollments, mockSubscriptionPlans } from "shared/services/mockData";

// ... rest of LoadingContext code ...// Defines subscription plans and provides functions to check feature limits.
const SubscriptionContext = createContext();


export const SubscriptionProvider = ({ children }) => {
    const [currentSubscriptionLevel, setCurrentSubscriptionLevel] = useState('Standard'); // Default subscription level
    const [limits, setLimits] = useState(mockSubscriptionPlans[currentSubscriptionLevel]);
    const { t } = useTranslation();

    useEffect(() => {
        setLimits(mockSubscriptionPlans[currentSubscriptionLevel]);
    }, [currentSubscriptionLevel]);

    // Checks if a user can perform an action based on their subscription limits.
    const canPerformAction = useCallback((feature, currentCount, courseId = null) => {
        if (limits[feature] === Infinity) {
            return true; // No limit for Premium
        }

        if (feature === 'maxBatchesPerCourse') {
            // For batches, we need to check the limit per course
            return currentCount < limits.maxBatchesPerCourse;
        } else if (feature === 'maxStudentsPerTutor') {
            // For students per tutor, we need to count students assigned to the current tutor
            // Assuming 'teacher1' is the current tutor for this mock
            const studentsForCurrentTutor = mockStudents.filter(student =>
                mockBatchEnrollments.some(enrollment => enrollment.studentId === student.id && enrollment.tutorId === 'teacher1')
            );
            return studentsForCurrentTutor.length < limits.maxStudentsPerTutor;
        } else {
            return currentCount < limits.maxCourses;
        }

        return currentCount < limits[feature];
    }, [limits]);

    return (
        <SubscriptionContext.Provider value={{ currentSubscriptionLevel, limits, canPerformAction }}>
            {children}
        </SubscriptionContext.Provider>
    );
};

export const useSubscription = () => {
    return useContext(SubscriptionContext);
};
